module.exports = __webpack_public_path__ + "static/media/paco-rabanne-olympea-big.d58955dd.png";